import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { actionCreators as orderActionCreators } from '@/checkout-instore-legacy/order/actions'
import {
  orderFormSelector,
  orderFormIdSelector,
} from '@/checkout-instore-legacy/order/selectors'
import Orders from '../components/Orders'

import { actionCreators as ordersActionCreators } from '../actions'

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(orderActionCreators, dispatch),
  ...bindActionCreators(ordersActionCreators, dispatch),
})

const mapStateToProps = (state) => ({
  orderForm: orderFormSelector(state),
  currentOrder: orderFormIdSelector(state),
  orders: state.orders,
  vendor: state.vendor.vendor,
})

export default connect(mapStateToProps, mapDispatchToProps)(Orders)
